import { render, staticRenderFns } from "./GlobalSections.vue?vue&type=template&id=1a61c3c3&"
import script from "./GlobalSections.vue?vue&type=script&lang=js&"
export * from "./GlobalSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports